<template>
    <div>
        <div class="progress-bar mb-2">
            <div class="progress-value" :class="atualizarCorBarra()" :style="{ width: `${calcularForcaSenha()}%` }"></div>
        </div>
        <span>
            <i :class="!lengthValid ? 'fa fa-exclamation-circle text-muted' : 'fa fa-check-circle text-success'"></i>
            <span class="ml-1">8 caracteres ou mais</span> </span
        ><br />
        <span>
            <i :class="!upperCaseValid ? 'fa fa-exclamation-circle text-muted' : 'fa fa-check-circle text-success'"></i>
            <span class="ml-1">Letras maiúsculas e minúsculas</span> </span
        ><br />
        <span>
            <i :class="!numberValid ? 'fa fa-exclamation-circle text-muted' : 'fa fa-check-circle text-success'"></i>
            <span class="ml-1">Pelo menos um número</span> </span
        ><br />
        <span>
            <i :class="!specialCharValid ? 'fa fa-exclamation-circle text-muted' : 'fa fa-check-circle text-success'"></i>
            <span class="ml-1">Pelo menos um caractere especial</span>
        </span>
    </div>
</template>

<script>
import { validaTamanhoSenha, validaLetrasSenha, validaNumerosSenha, validaCaractereEspecialSenha } from '@/shared/common/functions/validacoes'
export default {
    props:['senha'],
    data() {
        return {
            lengthValid: false,
            upperCaseValid: false,
            numberValid: false,
            specialCharValid: false,
        }
    },
    watch: {
        'senha'(value) {
            this.validaSenha(value)
        }
    },
    computed: {
        senhaValida() {
            return this.lengthValid && this.upperCaseValid && this.numberValid && this.specialCharValid
        }
    },
    methods: {
        validaSenha(senha) {
            this.lengthValid = validaTamanhoSenha(senha)
            this.upperCaseValid = validaLetrasSenha(senha)
            this.numberValid = validaNumerosSenha(senha)
            this.specialCharValid = validaCaractereEspecialSenha(senha)
        },
        calcularForcaSenha() {
            return [this.lengthValid, this.upperCaseValid, this.numberValid, this.specialCharValid].filter((requisito) => requisito).length * 25
        },
        atualizarCorBarra() {
            const forca = this.calcularForcaSenha()
            switch (forca) {
                case 25:
                    return 'red'
                case 50:
                    return 'orange'
                case 75:
                    return 'yellow'
                case 100:
                    return 'green'
            }
        }
    }
}
</script>

<style scoped>
.progress-bar {
    border-radius: 5px;
    background-color: #ccc;
    height: 7px;
    margin-top: 2px;
}
.progress-value {
    height: 100%;
    border-radius: 5px;
    transition: width 0.3s;
}
.red {
    background-color: red;
}
.orange {
    background-color: #ff8c00;
}
.yellow {
    background-color: #ffd700;
}
.green {
    background-color: green;
}
</style>
